const getHighestQualityVideo = (videos) => {
  const mp4 = videos.filter((video) => video.format === "mp4");
  const getVideoQuality = (video) => parseInt(video.quality, 10);
  return mp4.reduce(
    (result, video) => getVideoQuality(video) > getVideoQuality(result) ? video : result
  );
};
export {
  getHighestQualityVideo
};
//# sourceMappingURL=get-highest-quality-video.js.map
